import { useMutation } from '@tanstack/react-query'

import useNotyf from '../../../../hooks/useNotyf'
import { useShowGenericServerError } from '../../../../hooks/useShowGenericServerError'
import referralLinkService from '../../../../lib/services/referralLinkService'
import { useInvalidateReferralLinksQueries } from './useInvalidateReferralLinksQueries'

export function useDeleteLinkMutation() {
  const showGenericServerError = useShowGenericServerError()
  const invalidateReferralLinksQueries = useInvalidateReferralLinksQueries()
  const notyf = useNotyf()

  return useMutation({
    mutationFn: (referralLinkCode: string) =>
      referralLinkService.deleteReferralLink(referralLinkCode),
    onSuccess: async () => {
      await invalidateReferralLinksQueries()

      notyf.success('Link deleted successfully')
    },
    onError: showGenericServerError,
  })
}
